import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=17c1b30d&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"
import style0 from "./UserDocuments.vue?vue&type=style&index=0&id=17c1b30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1b30d",
  null
  
)

export default component.exports